import React from 'react';
import { Modal, Typography, Box, Backdrop, Button, Paper, CircularProgress } from '@mui/material';
import { useThemes } from '../Theme/theme';
import zIndex from '@mui/material/styles/zIndex';

const style = {
  position: 'absolute',
  top: '50%',
  left: '50%',
  transform: 'translate(-50%, -50%)',
  boxShadow: 24,
  outline: 'none',
  borderRadius: '4px',
};

const DeleteModal = ({ open, setOpen, setFn, func, text = 'item', text2, loading }) => {
  const { theme } = useThemes();
  console.log(text, 'text');
  const handleClose = (event, reason) => {
    if (reason !== 'backdropClick' && setOpen) {
      setOpen(false);
    }
    if (setFn) {
      setFn();
    }
  };

  const deleteItem = (e) => {
    // let arr = JSON.parse(localStorage.getItem(storage)).filter( (obj) => {
    //     if(obj.id!=itemId) {
    //         return obj
    //     }
    // })
    // localStorage.setItem(storage,JSON.stringify(arr));
    func(e);
    setOpen(false);
  };

  return (
    <Modal
      aria-labelledby="transition-modal-title"
      aria-describedby="transition-modal-description"
      open={open}
      onClose={handleClose}
      closeAfterTransition
      BackdropComponent={Backdrop}
      BackdropProps={{
        timeout: 500,
      }}
      sx={{zIndex:9999}}
    >
      {/* <Fade in={open}> */}
      <Paper sx={style}>
        <Box
          sx={{
            borderRadius: '4px',
            // backgroundColor: "white",
            padding: '15px',
            textAlign: 'center',
            overflowY: { xs: 'scroll', sm: 'hidden' },
            '.MuiTableCell-root': {
              padding: '10px 10px',
              fontSize: '13px',
            },
          }}
        >
          <Typography
            sx={{
              color: theme?.palette?.TmId.id.toString().includes('9') ? 'white' : 'rgb(60 60 60)',
              fontWeight: 'bold',
            }}
          >
            Do you want to {text2 ? text2 : 'delete'} this {text} ?
          </Typography>
        </Box>

        <Box
          sx={{
            display: 'flex',
            justifyContent: 'space-between',
            // flexDirection: { xs: "column", sm: "row" },
            paddingLeft: '15px',
            paddingRight: '15px',
            paddingBottom: '15px',
          }}
        >
          <Button color="error" onClick={handleClose} variant="contained" sx={{ flex: 1, margin: '5px', fontSize: '12px' }}>
            No
          </Button>
          <Button onClick={deleteItem} variant="outlined" sx={{ flex: 1, margin: '5px', fontSize: '12px' }}>
            Yes
          </Button>
        </Box>
        <Backdrop sx={{ color: '#fff', zIndex: (theme) => theme.zIndex.drawer + 1 }} open={loading}>
          <CircularProgress color="inherit" />
        </Backdrop>
      </Paper>
      {/* </Fade> */}
    </Modal>
  );
};

export default DeleteModal;
